import { PenColorSelector } from "./PenColorSelector";
import styles from "./PenMenu.module.css";
import { PenModeSelector } from "./PenModeSelector";
import { PenWidthSelector } from "./PenWidthSelector";

export const PenMenu = () => {
    return (
        <div className={styles.penToolSubMenu}>
            <PenModeSelector />
            <div className={styles.penToolSubMenuDivider} />
            <PenColorSelector />
            <div className={styles.penToolSubMenuDivider} />
            <PenWidthSelector />
        </div>
    );
};
